(function ($) {
  Drupal.behaviors.ehThewinkHpSpecialIssuesPodcastV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-special-issues-podcast-v1', context);

      formatter.each(function () {
        // var thisFormatter = $(this, context);
        var thisFormatter = $(this);

        // Lazyload
        site.util.lazyLoaded(thisFormatter);
      });
    }
  };
})(jQuery);
